import React from "react";
import { graphql, PageProps } from "gatsby";
import {
  PageQuery,
  PageBuilderSections_SanityOpeningHero_Fragment
} from "types/graphql-types";
import { PageContext } from "types/pageContext";
import SanityBuilderToComponents, {
  SanityBuilderSectionType
} from "components/PageBuilder";
import OpenGraph from "components/SEO/OpenGraph";
import { isPresent } from "src/utils/checks";

const CorporateIncentivesPageTemplate: React.FC<
  PageProps<PageQuery, PageContext>
> = ({ data, location }) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const page = data.page!;
  const sections = page.sections?.filter(isPresent) || [];

  const fallbackSeo = sections.find(
    (i) => i.__typename == "SanityOpeningHero"
  ) as PageBuilderSections_SanityOpeningHero_Fragment | null;

  const fallbackSeoTitle = fallbackSeo?.title?.localized;
  const fallbackSeoImage = fallbackSeo?.background?.asset?.url;

  return (
    <React.Fragment>
      <OpenGraph
        openGraph={data.page?.metadata?.openGraph}
        altTitle={fallbackSeoTitle}
        altImage={fallbackSeoImage}
        excludeFromSitemap={data.page?.metadata?.excludeFromSitemap}
      />
      {data.page && sections?.length > 0 && (
        <SanityBuilderToComponents
          sections={data.page.sections as SanityBuilderSectionType[]}
          location={location}
        />
      )}
    </React.Fragment>
  );
};

export const query = graphql`
  query CorporateIncentivesPage($id: String) {
    page: sanityCorporateIncentivePage(id: { eq: $id }) {
      metadata {
        excludeFromSitemap
        openGraph {
          ...OpenGraphMetaTags
        }
      }

      title {
        localized
      }
      sections {
        ...PageBuilderSections
      }
    }
  }
`;

export default CorporateIncentivesPageTemplate;
